export enum UserRole {
  OrganizationAdmin = 'organization_admin',
  OrganizationRepresentative = 'organization_representative',
  OrganizationUser = 'organization_user',
  DataspaceAuthority = 'dataspace_authority',
}

/**
 * Numeric strength level for each role.
 * A role may only be assigned when the target role's level is strictly less than
 * the assigner's own level.
 */
export const ROLE_LEVELS: Record<string, number> = {
  [UserRole.OrganizationUser]: 0,
  [UserRole.OrganizationAdmin]: 1,
  [UserRole.OrganizationRepresentative]: 2,
  [UserRole.DataspaceAuthority]: 3,
};

/**
 * Returns the maximum role level for the given array of role name strings.
 * Role names are expected in lower-case snake_case (as stored in the JWT).
 */
export function maxRoleLevel(roles: string[]): number {
  return roles.reduce((max, role) => {
    const level = ROLE_LEVELS[role.toLowerCase()] ?? -1;
    return level > max ? level : max;
  }, -1);
}
